export default "__VITE_ASSET__$M0X9kDj__"